import { uploadImg } from '@/api/admin';

export default function usePsd() {
  const getUrl = async (data) => {
    if (data.src && data.src.startsWith('data:image')) {
      const url = await uploadImgByBase64(data.src);
      data.src = url;
      data.crossOrigin = 'anonymous';
    }
    if (data.objects) {
      for (const item of data.objects) {
        await getUrl(item);
      }
    }
    return data;
  };

  const uploadImgByBase64 = async (base64) => {
    const formData = createFormData(base64, '123.png');
    const res = await uploadImg(formData);
    return res.data[0].formatUrl;
  };

  const createFormData = (dataurl, filename = 'image.png') => {
    // 将 dataURL 转换为 File 对象
    const dataURLtoFile = (dataurl, filename) => {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    };

    const file = dataURLtoFile(dataurl, filename);
    const formData = new FormData();
    const time = new Date();
    formData.append('files', file, `${time.getTime()}`);
    return formData;
  };
  return { getUrl };
}
